(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  if (window.AFBCollectionInfiniteScroll) return;
  window.AFBCollectionInfiniteScroll = true;
  let observer;
  let loading = false;
  const connect = () => {
    if (observer) observer.disconnect();
    const pager = document.querySelector('[data-afb-infinite-pagination]');
    const link = pager?.querySelector('.afb-infinite-pagination__link');
    const grid = document.querySelector('#product-grid');
    if (!pager || !link || !grid) return;
    observer = new IntersectionObserver(async entries => {
      if (!entries[0].isIntersecting || loading) return;
      loading = true;
      pager.classList.add('is-loading');
      try {
        const response = await fetch(link.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Unable to load products');
        const documentNext = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = documentNext.querySelectorAll('#product-grid > .grid__item');
        items.forEach(item => grid.appendChild(item));
        const nextLink = documentNext.querySelector('[data-afb-infinite-pagination] .afb-infinite-pagination__link');
        if (nextLink) {
          link.href = nextLink.href;
          pager.classList.remove('is-loading');
        } else {
          pager.remove();
          observer.disconnect();
        }
      } catch (error) {
        pager.classList.remove('is-loading');
      } finally {
        loading = false;
      }
    }, { rootMargin: '600px 0px' });
    observer.observe(pager);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-afb-columns]');
    if (!button) return;
    const grid = document.querySelector('#product-grid');
    if (!grid) return;
    grid.classList.remove('afb-grid-cols-2', 'afb-grid-cols-3');
    if (button.dataset.afbColumns !== '4') grid.classList.add('afb-grid-cols-' + button.dataset.afbColumns);
    document.querySelectorAll('[data-afb-columns]').forEach(control => control.setAttribute('aria-pressed', control === button ? 'true' : 'false'));
  });
  const container = document.querySelector('#ProductGridContainer');
  if (container) new MutationObserver(connect).observe(container, { childList: true, subtree: false });
  connect();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-afb-recommendations]');
    if (!section || section.querySelector('.afb-recommendations__grid')) return;
    fetch(section.dataset.url).then((response) => response.text()).then((text) => {
      const documentFragment = new DOMParser().parseFromString(text, 'text/html');
      const replacement = documentFragment.querySelector('[data-afb-recommendations]');
      if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
    }).catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();
})();
